import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type { TOrderInvoiceResponse, TOrderListResponse, TOrderResponse } from '~/modules/user/types/order';

export default class Orders extends AbstractFetch {
  private static readonly USER_ORDERS = 'v1/users/{id}/orders/';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async getUserOrders(id: number, query: string): Promise<TOrderListResponse> {
    const url = Orders.USER_ORDERS.replace('{id}', String(id));

    return this.fetch(`${url}${query}`);
  }
}
